import { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { navigation } from '../data/content'

export function SiteHeader() {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  useEffect(() => setOpen(false), [location.pathname])
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [open])

  return (
    <header className="site-header">
      <Link className="wordmark" to="/" aria-label="Boostpad home">BOOSTPAD</Link>
      <nav className="desktop-nav" aria-label="Primary navigation">
        {navigation.map(item => <NavLink key={item.href} to={item.href}>{item.label}</NavLink>)}
      </nav>
      <button className="menu-toggle" type="button" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} aria-controls="mobile-menu" onClick={() => setOpen(value => !value)}>
        <span /><span />
      </button>
      <div id="mobile-menu" className="mobile-menu" data-open={open} aria-hidden={!open}>
        <nav aria-label="Mobile navigation">
          {navigation.map((item, index) => <NavLink key={item.href} to={item.href}><span>0{index + 1}</span>{item.label}</NavLink>)}
        </nav>
        <p>Products · Apps · AI · Experiences</p>
      </div>
    </header>
  )
}
